var map = {
	"./arrow-down.svg": 130,
	"./arrow-left.svg": 131,
	"./arrow-right.svg": 132,
	"./arrow-up.svg": 133,
	"./back-arrow.svg": 134,
	"./balneo.svg": 135,
	"./check.svg": 136,
	"./chevron-down.svg": 137,
	"./chevron-left.svg": 138,
	"./chevron-right.svg": 139,
	"./cross.svg": 140,
	"./facebook.svg": 141,
	"./health.svg": 142,
	"./instagram.svg": 143,
	"./link-arrow.svg": 144,
	"./plus.svg": 145,
	"./spa.svg": 146,
	"./sport.svg": 147,
	"./trash.svg": 148,
	"./twitter.svg": 149,
	"./warning.svg": 150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;